import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SubAdminRoute from "./authGuards/subAdminGuard";
import SuperAdminRoute from "./authGuards/superAdminGuard";
import FormBuilderCallback from "./components/FormBuilderCallback/FormBuilderCallback";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Login from "./pages/Login/Login";
import Switch from "./pages/SwitchCompany/SwitchCompany";
import MailLogin from "./pages/MailLogin/MailLogin";
import SetPassword from "./pages/SetPassword/SetPassword";
import Signup from "./pages/Sign-up/Sign-up";
import CompanyOnboard from "./pages/SubscriberSupplierAdmin/CompanyOnboard/CompanyOnboard";
import SubAdminMain from "./pages/SubscriberSupplierAdmin/SubAdminMain/SubAdminMain";
import SupplierOnboard from "./pages/SubscriberSupplierAdmin/SupplierOnboard/SupplierOnboard";
import SuperAdminMain from "./pages/SuperAdmin/SuperAdminMain/SuperAdminMain";
import UserVerification from "./pages/User/UserVerification";
import SwitchCompany from "./pages/SwitchCompany/SwitchCompany";
import AuthRoute from "./authGuards/AuthGuard";
import AppLander from "./pages/Lander/AppLander";
import RedirectToLogin from "./core/router/RedirectHandler";

const RoutesList = () => {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/sign_up" element={<Signup />}></Route>
        <Route path="/mail_verify/:invite_key" element={<MailLogin />}></Route>
        <Route path="/user_verify" element={<UserVerification />}></Route>
        <Route path="/reset_password" element={<SetPassword />}></Route>
        <Route path="/set_password/:invite_key" element={<SetPassword />}></Route>
        <Route path="/formbuilder" element={<FormBuilderCallback />} />
        <Route path="/forgot_password" element={<ForgotPassword />}></Route>
        <Route path="/esg" element={<AppLander />}></Route>

        {/** Super admin routes*/}
        <Route
          path="admin/*"
          element={
            <SuperAdminRoute>
              <SuperAdminMain />
            </SuperAdminRoute>
          }
        />
        {/** Super admin routes end */}
        {/** Subscriber/Supplier admin routes */}
        <Route path="company_admin/company_onboard/:invite_key" element={<CompanyOnboard />} />
        <Route path="company_admin/supplier_details_onboard/:companyId/:supplierDetailsId" element={<SupplierOnboard />} />
        <Route
          path="company_admin/*"
          element={
            <SubAdminRoute>
              <SubAdminMain />
            </SubAdminRoute>
          }
        />
        {/** Subscriber/Supplier admin routes end */}

        {/** Consultant routes*/}
        <Route
          path="consultant/*"
          element={
            <AuthRoute>
              <Routes>
                <Route path="/switch" element={<SwitchCompany />} />
              </Routes>
            </AuthRoute>
          }
        />
        <Route path="*" element={<RedirectToLogin />} />
      </Routes>
    </>
  );
};
export default RoutesList;
